module.exports = {
          srcSet: __webpack_public_path__ + "5471e526884a914aca854b0f097ba1f8-9.png"+" 9w",
          images:[ {path: __webpack_public_path__ + "5471e526884a914aca854b0f097ba1f8-9.png",width: 9,height: 16}],
          src: __webpack_public_path__ + "5471e526884a914aca854b0f097ba1f8-9.png",
          toString:function(){return __webpack_public_path__ + "5471e526884a914aca854b0f097ba1f8-9.png"},
          
          width: 9,
          height: 16
        }